module.exports = __webpack_public_path__ + "img/MM.62780d15.svg";